import { Row, Col, Carousel } from 'react-bootstrap'

import ImageElement from './ImageElement'

const CarouselElement = ({data}) => {
  // console.log('CarouselElement data:', data)
  return (
    <Row>
      <Col className='mt-3'>
        <Carousel indicators={false} className='slider'>
          {data.images.map((element, index) => (
            <Carousel.Item key={index}>
              <ImageElement content={`${process.env.REACT_APP_CDN}/${process.env.REACT_APP_IMAGE_BUCKET}/${element.name}`} aspectRatio="6/4" />
            </Carousel.Item>
          ))}
        </Carousel>
    </Col>
    </Row>
  )
}

export default CarouselElement